'use client';

import BlogCard from './BlogCard';

interface BlogGridProps {
  currentLang?: 'sl' | 'en';
  selectedCategory: string;
}

export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  alt: string;
}

export default function BlogGrid({ currentLang = 'sl', selectedCategory }: BlogGridProps) {
  const articles: Article[] = [
  {
    id: 'article_1',
    slug: 'kako-zaceti-z-cebelarstvom',
    title: currentLang === 'sl' ? 'Kako začeti z čebelarstvom' : 'How to Start Beekeeping',
    excerpt:
    currentLang === 'sl' ? 'Popoln vodič za začetnike, ki želijo vstopiti v svet čebelarstva. Oprema, znanje in prvi koraki.' : 'Complete guide for beginners entering the world of beekeeping. Equipment, knowledge, and first steps.',
    category: currentLang === 'sl' ? 'Nasveti' : 'Tips',
    author: 'Marko Čebelar',
    date: '15. januar 2026',
    readTime: '8 min',
    image: "https://images.unsplash.com/photo-1569393875125-38ebacc5288d",
    alt: 'Beginner beekeeper in protective suit examining beehive frame with honeycomb'
  },
  {
    id: 'article_2',
    slug: 'zdravilne-lastnosti-meda',
    title: currentLang === 'sl' ? 'Zdravilne lastnosti meda' : 'Healing Properties of Honey',
    excerpt:
    currentLang === 'sl' ? 'Odkrijte, kako med pomaga pri različnih zdravstvenih težavah in zakaj je naravno zdravilo.' : 'Discover how honey helps with various health issues and why it is a natural remedy.',
    category: currentLang === 'sl' ? 'Zdravje' : 'Health',
    author: 'Dr. Ana Medič',
    date: '10. januar 2026',
    readTime: '6 min',
    image: "https://images.unsplash.com/photo-1700798981606-53966aea6501",
    alt: 'Golden honey dripping from wooden honey dipper into glass jar with herbs'
  },
  {
    id: 'article_3',
    slug: 'zgodba-o-kranjski-cebeli',
    title: currentLang === 'sl' ? 'Zgodba o kranjski čebeli' : 'Story of the Carniolan Bee',
    excerpt:
    currentLang === 'sl' ? 'Spoznajte slovensko avtohtono čebelo, ki je znana po svoji mirnosti in pridnosti.' : 'Meet the Slovenian native bee, known for its calmness and diligence.',
    category: currentLang === 'sl' ? 'Zgodbe' : 'Stories',
    author: 'Janez Novak',
    date: '5. januar 2026',
    readTime: '10 min',
    image: "https://images.unsplash.com/photo-1658834566036-f76136e672f1",
    alt: 'Close-up of Carniolan bee on purple flower collecting pollen'
  },
  {
    id: 'article_4',
    slug: 'medeni-recepti-za-zimo',
    title: currentLang === 'sl' ? 'Medeni recepti za zimo' : 'Honey Recipes for Winter',
    excerpt:
    currentLang === 'sl' ? 'Ogrejte se s temi okusnimi recepti, kjer je med glavna zvezda. Od čajev do sladic.' : 'Warm up with these delicious recipes where honey is the star. From teas to desserts.',
    category: currentLang === 'sl' ? 'Recepti' : 'Recipes',
    author: 'Maja Kuhar',
    date: '28. december 2025',
    readTime: '5 min',
    image: "https://images.unsplash.com/photo-1615629748241-97efffef4ed2",
    alt: 'Warm tea with honey and lemon slices in glass mug on wooden table'
  },
  {
    id: 'article_5',
    slug: 'trajnostno-cebelarstvo',
    title: currentLang === 'sl' ? 'Trajnostno čebelarstvo' : 'Sustainable Beekeeping',
    excerpt:
    currentLang === 'sl' ? 'Kako čebelariti na način, ki spoštuje naravo in zagotavlja prihodnost čebel.' : 'How to keep bees in a way that respects nature and ensures the future of bees.',
    category: currentLang === 'sl' ? 'Trajnostnost' : 'Sustainability',
    author: 'Peter Zeleni',
    date: '20. december 2025',
    readTime: '12 min',
    image: "https://images.unsplash.com/photo-1657751774799-0701b4f384d0",
    alt: 'Sustainable beehives in natural meadow with wildflowers and mountains'
  },
  {
    id: 'article_6',
    slug: 'apiterapija-za-sproščanje',
    title: currentLang === 'sl' ? 'Apiterapija za sproščanje' : 'Apitherapy for Relaxation',
    excerpt:
    currentLang === 'sl' ? 'Doživite terapevtsko moč čebel in njihovih izdelkov za popolno sprostitev.' : 'Experience the therapeutic power of bees and their products for complete relaxation.',
    category: currentLang === 'sl' ? 'Zdravje' : 'Health',
    author: 'Dr. Ana Medič',
    date: '15. december 2025',
    readTime: '7 min',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_109f9f019-1769981988600.png",
    alt: 'Person relaxing during apitherapy session with honey massage treatment'
  }];


  // Filter articles based on selected category
  const filteredArticles = selectedCategory === 'all' 
    ? articles 
    : articles.filter(article => {
        const categoryMap: { [key: string]: string } = {
          'tips': currentLang === 'sl' ? 'Nasveti' : 'Tips',
          'stories': currentLang === 'sl' ? 'Zgodbe' : 'Stories',
          'health': currentLang === 'sl' ? 'Zdravje' : 'Health',
          'recipes': currentLang === 'sl' ? 'Recepti' : 'Recipes',
          'sustainability': currentLang === 'sl' ? 'Trajnostnost' : 'Sustainability',
        };
        return article.category === categoryMap[selectedCategory];
      });

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {filteredArticles.map((article) =>
      <BlogCard key={article.id} article={article} currentLang={currentLang} />
      )}
    </div>);

}